import { ReactNode } from "react";
import { Box, Skeleton } from "@mui/material";
import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { RiskReportCardBackground, useRiskReportCardStyles } from "./RiskReportCard.styles";

interface RiskReportCardProps {
    header: string;
    background: RiskReportCardBackground;
    isLoading?: boolean;
    // Rendered in the top-right corner (e.g. a progress ring), mirroring the dashboard count card.
    topRight?: ReactNode;
    children: ReactNode;
}

function RiskReportCard({ header, background, isLoading, topRight, children }: RiskReportCardProps) {
    const styles = useRiskReportCardStyles(background);
    const skeletonColor = background === "violet" ? "rgba(0, 44, 117, 0.15)" : "rgba(255, 255, 255, 0.25)";

    return (
        <Box sx={styles.card}>
            {isLoading ? (
                <>
                    <Skeleton variant="text" width={180} sx={{ bgcolor: skeletonColor }} />
                    <Skeleton variant="rounded" width={90} height={52} sx={{ bgcolor: skeletonColor, mt: 2.5 }} />
                </>
            ) : (
                <>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 }}>
                        <DotLegalHeader color={background === "violet" ? "primary" : "white"} headerStyle="medium" marginBottom={0}>
                            {header.toUpperCase()}
                        </DotLegalHeader>
                        {topRight}
                    </Box>
                    <Box sx={styles.body}>{children}</Box>
                </>
            )}
        </Box>
    );
}

export default RiskReportCard;
